import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="spaces-start-time"
export default class extends Controller {
  static targets = ["modal", "btnscont"]

  connect() {
    this.hideOptions();

    const buttons = this.element.querySelectorAll('.start-time_btn');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        if(button.classList.contains('active')){
          button.classList.remove('active');
        } else if(!button.classList.contains('unav')){
          buttons.forEach(button => {
            button.classList.remove('active');
          });
          button.classList.toggle('active');
        }
        this.sendTime();
      })
    });

    let inputFields = this.element.querySelectorAll('div.input');
    inputFields.forEach(e => {
      e.addEventListener('click', () => {
        this.open();
      })
    });

    let startMinuteField = document.querySelector('#spaces_finder_start_minute')
    if(startMinuteField){
      console.log('here')
      if(startMinuteField.value == ''){
        console.log('here 1')
        startMinuteField.value = 0;
        console.log('here 2')
      }
    }
  }

  open() {
    this.modalTarget.classList.add('open');
  }
  close() {
    this.modalTarget.classList.remove('open');
  }
  hideOptions() {
    const options = this.element.querySelectorAll('option');
    options.forEach(option => {
      option.classList.add('hidden');
    });
  }

  sendTime() {
    let hourSelect
    let minuteSelect
    let spacesFinder = document.querySelector('#spaces_finder_start_hour')
    let spaceSingle = document.querySelector('#booking_start_time_hours')

    if(spacesFinder){
      hourSelect = document.querySelector('#spaces_finder_start_hour');
      minuteSelect = document.querySelector('#spaces_finder_start_minute');
    } else if(spaceSingle){
      hourSelect = document.querySelector('#booking_start_time_hours');
      minuteSelect = document.querySelector('#booking_start_time_minutes');
    }

    let selected = this.btnscontTarget.querySelector('.active').innerText.trim();
    let timeArray = selected.split(":");
    let hour = timeArray[0];
    let minute = timeArray[1];
    hourSelect.value = hour;

    if(spacesFinder){ 
      if(minute == '00'){
        minuteSelect.value = 0;
      } else {
        minuteSelect.value = minute;
      }
    }else if(spaceSingle){ 
      if(minute == '00'){
        minuteSelect.value = '00';
      } else {
        minuteSelect.value = minute;
      }
    }
    
  }


}
